import { render, staticRenderFns } from "./Finishing.vue?vue&type=template&id=cedb9944&scoped=true&"
import script from "./Finishing.vue?vue&type=script&lang=js&"
export * from "./Finishing.vue?vue&type=script&lang=js&"
import style0 from "./Finishing.vue?vue&type=style&index=0&id=cedb9944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedb9944",
  null
  
)

export default component.exports